export default __webpack_public_path__ + "static/media/42Dimic.07fc8204.jpg";